import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSelector.css';

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  
  const availableLanguages = [
    { code: 'en-US', name: 'language.english' },
    { code: 'ar-SA', name: 'language.arabic' },
  ];

  const changeLanguage = (event) => {
    i18n.changeLanguage(event.target.value);
    document.documentElement.lang = event.target.value;
    document.documentElement.dir = event.target.value === 'ar-SA' ? 'rtl' : 'ltr';
  };

  return (
    <div className="language-selector">
      <select 
        value={i18n.language} 
        onChange={changeLanguage}
        className="language-selector__select"
      >
        {availableLanguages.map((lang) => (
          <option key={lang.code} value={lang.code}>
            {i18n.t(lang.name)}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSelector;
